module.exports = __webpack_public_path__ + "img/20041c48cfa96dedd08264faaf8a13b4.png";